// extracted by mini-css-extract-plugin
module.exports = {"shxakni":"shxakni"};